export const getEmail = lang => {
    switch (lang) {
        case 'pl': {
            return 'demopl@e-stado.net'
        }
        case 'en': {
            return 'demoen@e-stado.net'
        }
        case 'ru': {
            return 'demoru@e-stado.net'
        }
        case 'hu': {
            return 'demohu@e-stado.net'
        }
        case 'es': {
            return 'demoes@e-stado.net'
        }
        case 'ko': {
            return 'demoko@e-stado.net'
        }
        default: {
            return 'demopl@e-stado.net'
        }
    }
}

export const getPassword = () => 'estado'